import { fromJS } from 'immutable'
import {
  TIMESHEET_APPROVE_REQUEST,
  TIMESHEET_APPROVE_SUCCESS,
  TIMESHEET_APPROVE_FAILURE,
  TIMESHEET_APPROVE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case TIMESHEET_APPROVE_REQUEST:
      return state
        .set('isFetching', true)
    case TIMESHEET_APPROVE_SUCCESS:
      return state
        .set('responseTimesheet', fromJS(action.payload.responseTimesheet))
        .set('isFetching', false)
        .set('status', 200)
        .set('message', 'Successfully.')
    case TIMESHEET_APPROVE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('responseTimesheet', fromJS(action.payload.message))
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
    case TIMESHEET_APPROVE_RESET:
      return state
        .delete('responseTimesheet')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/timesheet/timesheet-approve-reducer.js